import { get, post } from 'common/utils/request';
export var fetchConversionApi = function () {
    return get('/companies/conversion');
};
export var editConversionApi = function (data) {
    return post('/settings/conversion', data);
};
